module.exports = __webpack_public_path__ + "6cf6f984adb4e8722d5bf3d6b68613a4.png";